import { useSelector } from 'react-redux';

import { getUser } from 'shared/selectors/user';

export function useUser() {
  const user = useSelector(getUser);

  if (!user.isAuthenticated) {
    return null;
  }

  return user;
}
